import { TrialDto, TrialHistoryPage } from "@decibeltrade/sdk";

import { addressesEqual } from "@/utils/address";

export function deriveProfitsKeptUsd({
  activeTrial,
  campaignAddr,
  historyPages,
}: {
  activeTrial: TrialDto | null;
  campaignAddr: string | undefined;
  historyPages: TrialHistoryPage[] | undefined;
}): number | null {
  if (activeTrial?.status === "Active") return null;
  if (activeTrial?.user_payout_usd != null) return activeTrial.user_payout_usd;
  if (!campaignAddr || !historyPages) return null;

  const settled = historyPages
    .flatMap((p) => p.history)
    .find(
      (row) =>
        addressesEqual(row.campaign_addr, campaignAddr) &&
        row.status !== "Active" &&
        row.user_payout_usd != null,
    );

  return settled?.user_payout_usd ?? null;
}
